import React from 'react';
import ModalLayer from './ModalLayer';
import { invitePopupLine } from '../shared/inviteDelivery';

const SAMPLES = {
  pending: {
    id: 'c1',
    outcome: 'created',
    invite_status: 'not_sent',
    invite_code: 'AB12CD',
  },
  sent: {
    id: 'c1',
    outcome: 'created',
    invite_status: 'sent',
    invite_channel: 'email',
    invite_code: 'AB12CD',
  },
  mail: {
    id: 'c1',
    outcome: 'created',
    invite_status: 'sent',
    invite_channel: 'mail',
    invite_code: 'AB12CD',
  },
};

/** Development-only look at the Client Invited Successfully delivery line. */
export default function ClientInvitePreview() {
  const params = new URLSearchParams(window.location.search);
  const result = SAMPLES[params.get('delivery')] || SAMPLES.pending;
  const emailed = result.invite_status === 'sent';
  return (
    <ModalLayer
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <div className="app-modal-card" style={{ background: '#fff', color: '#111', borderRadius: '1rem', padding: '1.5rem', width: 'min(100%, 28rem)' }}>
        <h2 style={{ margin: '0 0 0.75rem', fontSize: '1.25rem' }}>Client Invited Successfully!</h2>
        <p style={{ marginBottom: '0.5rem' }}>Share this code with your client:</p>
        <div style={{
          background: '#59c4c4',
          color: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          fontSize: '2rem',
          fontWeight: 'bold',
          letterSpacing: '0.3em',
          textAlign: 'center',
          marginBottom: '1rem',
        }}
        >
          AB12CD
        </div>
        <p data-testid="invite-delivery" style={{ margin: '0 0 0.75rem', fontWeight: 600 }}>
          {invitePopupLine(result)}
        </p>
        <p style={{ margin: '1rem 0', color: '#64748b', fontSize: '0.9rem', lineHeight: 1.6 }}>
          They can open the invite link, choose Homeowner Login, and enter this code.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button type="button" style={{ flex: 1, background: '#10b981', color: '#fff', border: 0, borderRadius: '0.5rem', padding: '0.75rem 1rem' }}>
            Copy invite message
          </button>
          {emailed ? null : (
            <button type="button" style={{ flex: 1, background: '#0f766e', color: '#fff', border: 0, borderRadius: '0.5rem', padding: '0.75rem 1rem' }}>
              Email invite
            </button>
          )}
        </div>
      </div>
    </ModalLayer>
  );
}
